import React from "react"

import { ProductPositionRemarkInput } from "./inputs/ProductPositionRemarkInput"

export const ProductPositionFormRemarkTab = React.memo(() => (
  <div className="product-position-form__tab-content product-position-form__tab-content--remark">
    <ProductPositionRemarkInput />
  </div>
))
